import * as React from 'react';
import { AccountLink } from '@/lib/navigation/links/AccountLink';
import laptopPerson from '../../../../assets/images/laptop_person.svg';
import { BackToSetup } from './BackToSetup';

export const OnboardingTicketView = () =>
  (
    <div id="ticket-view-onboarding" className="avo-ui-3">
      <BackToSetup />
      <img className="complete" src={laptopPerson} alt="laptop-person" />
      <div className="container-wrap">
        <div className="container">
          <h2>Welcome to Avochato!</h2>
          <p>Let&apos;s send your first customer message by tapping the button below.</p>
          <button
            type="button"
            className="button bright-green md"
            onClick={() => document.getElementById('outbound-modal-btn').click()}
          >
            Start a new conversation
          </button>
        </div>
        <hr />
        <p>
          Let&apos;s get your account set up.&nbsp;
          <AccountLink path="onboarding">
            <span
              style={{ cursor: 'pointer' }}
              className="link-blue"
            >
              Go to Quick Setup Page.
            </span>
          </AccountLink>
        </p>
      </div>
    </div>
  );
